import queryKeys from './queryKeys';
import queryHelper from './queryHelper';
import { tagTypes } from '../../constants/tagTypes';

export const updateUrlWithSearchResultParams = (result, sortKey) => {
  queryHelper.updateQueryWithValues({
    [queryKeys.SEARCH.sessionId]: result?.serviceCallInformation?.sessionId,
    [queryKeys.SEARCH.sortKey]: sortKey,
  });
};

export const updateUrlWithPriceMatrixSearchResultParams = (result) => {
  queryHelper.updateQueryWithValues({
    [queryKeys.SEARCH.sessionId]: result?.serviceCallInformation?.sessionId,
  });
};

export const updateUrlWithSessionId = (value) => {
  queryHelper.updateQueryWithValues({
    [queryKeys.SEARCH.sessionId]: value,
  });
};

export const getSessionIdFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.sessionId);
};

export const getTransportKeyFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.transportKey);
};

export const updateUrlWithSortKey = (value) => {
  queryHelper.updateQueryWithValues({
    [queryKeys.SEARCH.sortKey]: value,
  });
};

export const getSortKeyFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.sortKey);
};

export const getFlightSequenceKeyFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.flightSeqKey);
};

export const getAccomodationKeyFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.accomodationKey);
};

export const getRoomGroupKeyFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.roomGroupKey);
};

export const getIsStandaloneFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.isStandalone);
};

export const getScrollyPossy = () => {
  return queryHelper.getQueryKeyValue('scrollypossy');
};

export const getFilterStateFromQuery = () => {
  const state = {};
  const keysToFetch = Object.keys(queryKeys.FILTER);

  queryHelper
    .getQueryKeyValues(keysToFetch.map((key) => queryKeys.FILTER[key]))
    .forEach((value, i) => {
      state[keysToFetch[i]] = value;
    });

  return state;
};

export const getFilterQueriesAsString = () => {
  const keysToFetch = Object.keys(queryKeys.FILTER);
  const query = [];

  queryHelper
    .getQueryKeyValues(keysToFetch.map((key) => queryKeys.FILTER[key]))
    .forEach((value, i) => {
      if (value) {
        query.push(`${queryKeys.FILTER[keysToFetch[i]]}=${value}`);
      }
    });

  return query.join('&');
};

export const updateQueryWithValues = (kvp) => {
  queryHelper.updateQueryWithValues(kvp);
};

export const getDepartureIdFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.QUERY.departureId);
};

export const getDepartureWvIdFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.QUERY.departureWvId);
};

export const getDepartureCodeFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.QUERY.departureCode);
};

export const getDepartureDateFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.QUERY.departureDate);
};

export const getReturnDateFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.QUERY.returnDate);
};

export const getDurationFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.QUERY.duration);
};

export const getRoomDistributionFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.QUERY.roomDistribution);
};

export const getAgesFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.QUERY.ages);
};

export const getNumberOfRoomsFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.QUERY.numberOfRooms);
};

export const getAdultsFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.QUERY.adults);
};

export const getChildrenAgesFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.QUERY.childrenAges);
};

export const getResortIdFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.QUERY.resortId);
};

export const getResortWvIdFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.QUERY.resortWvId);
};

export const getAreaIdFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.QUERY.areaId);
};

export const getCountryIdFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.QUERY.countryId);
};

export const getDestinationAirportIdFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.QUERY.destinationAirportId);
};

export const getTdmRuleIdFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.tdmRuleId);
};

export const getPriceFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.price);
};

export const getSelectedHotelCodeFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.selectedHotelCode);
};

export const getHotelIdFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.hotelId);
};

export const getTransportIdFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.transportId);
};

export const getBestPriceFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.bestPrice);
};

export const getFastestFlightFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.fastestFlight);
};

export const getAccomodationKeysFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.accomodationKeys);
};

export const getSequenceFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.sequence);
};

export const getTripRuleIdFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.tripRuleId);
};

export const getSelectedCabinFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.selectedCabin);
};

export const getCruiseCodeFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.cruiseCode);
};

export const getCruiseIdFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.cruiseId);
};

export const getTagsFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.tags);
};

export const getRecommendedFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.recommended);
};

export const getTripContextFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.tripContext);
};

export const isUpsell = () => {
  const selectedHotelCode = queryHelper.getQueryKeyValue(
    queryKeys.SEARCH.selectedHotelCode,
  );
  return !!selectedHotelCode;
};

export const isFlightOnly = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.categoryId) === '5';
};

export const isStopOver = () => {
  const tags =
    queryHelper.getQueryKeyValue(queryKeys.SEARCH.tags)?.split(',') || [];
  return tags.includes(tagTypes.stopover);
};

export const isTdmPackage = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.tdmRuleId) !== '';
};

export const isCruise = () => {
  return !!queryHelper.getQueryKeyValue(queryKeys.SEARCH.selectedCabin);
};

export const isCombination = () => {
  // stop over || theater || other types of combinations
  return (isStopOver() || isTdmPackage()) && !isUpsell();
};

export const isChangeCabinPage = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.changeCabin) === 'true';
};

export const getCabinClassFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.cabinClass);
};
export const getDirectFlightFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.directFlight);
};
export const getIncludeBaggageFromUrl = () => {
  return queryHelper.getQueryKeyValue(queryKeys.SEARCH.includeBaggage);
};

export const getCruiseFilterStateFromQuery = (query = null) => {
  const state = {};
  const keysToFetch = Object.values(queryKeys.CRUISE_FILTERS);

  if (query) {
    const params = new URLSearchParams(query);
    keysToFetch.forEach((key) => {
      if (params.get(key) != null) {
        state[key] = params.get(key);
      }
    });
  } else {
    queryHelper.getQueryKeyValues(keysToFetch).forEach((value, i) => {
      state[keysToFetch[i]] = value;
    });
  }

  return state;
};
